module.exports = __webpack_public_path__ + "img/vowelcombolaunch.78ed4349.png";